import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { DocumentFormVM } from 'front-office/view-models/document/document-form';
import AccordionPersonForm from './form';

interface AccordionPersonProps {
  disabled?: boolean;
}

const AccordionPersonComponent = ({ disabled }: AccordionPersonProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<DocumentFormVM>();

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Persona</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionPersonForm
            disabled={disabled}
            onChange={formContext.handleChange}
            values={formContext.values.person || null}
            generality={formContext.values.generality}
            citizenship={formContext.values.citizenship}
            family={formContext.values.familyCoexistence}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionPersonComponent.displayName = 'Accordion person component';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
